import React from 'react';
import { Button, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Email } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { BusinessDetailsOut } from '../../../api';
import { useLanguage } from '../../../utils/GeneralUtils';

interface AboutSectionProps {
  businessDetails?: BusinessDetailsOut;
  accountName: string;
}

export const AboutSection = ({ businessDetails, accountName }: AboutSectionProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const language = useLanguage();

  const aboutContent = businessDetails?.about_content?.[language];
  const email = businessDetails?.contact?.email;

  if (!aboutContent) {
    return null;
  }

  return (
    <Grid container flexDirection="column" mb={isSmallScreen ? 6 : 10}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          marginBottom: isSmallScreen ? 3 : 4,
          textAlign: 'center',
        }}>
        {t('storefront.about')} {accountName}
      </Typography>
      <Grid
        container
        flexDirection="column"
        sx={{
          maxWidth: 800,
          margin: '0 auto',
          lineHeight: '24px',
          '& *': {
            fontFamily: 'Assistant !important',
            fontSize: 'inherit !important',
          },
          '& p': {
            margin: 0,
          },
        }}
        dangerouslySetInnerHTML={{ __html: aboutContent }}
      />
      {email && (
        <Grid container justifyContent="center" mt={4}>
          <Button variant="outlined" startIcon={<Email />} href={`mailto:${email}`} sx={{ textTransform: 'none' }}>
            {t('storefront.contactUs')}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};
